import { ApexOptions } from 'apexcharts';
import React from 'react';
import Chart from 'react-apexcharts';


// Define a type for the chart attributes
type ChartProps = {
  options: ApexOptions;
  series: any[];
  type: any['chart']['type']; // Use the specific type from ApexOptions
  width: number;
  height: number;
};

const BarChart: React.FC<ChartProps> = ({ options, series, type, width, height }) => {
  return (
    <div>
      <Chart options={options} series={series} type={type} width={width} height={height} />
    </div>
  );
};

export default BarChart;
